import Date from '../form-elements/Date';
import FileUpload from '../form-elements/FileUpload';
import Hint from '../form-elements/Hint';
import Line from '../form-elements/Line';
import MultiLineInput from '../form-elements/MultiLineInput';
import MultipleChoice from '../form-elements/MultipleChoice';
import Paragraph from '../form-elements/Paragraph';
import Select from '../form-elements/Select';
import Signature from '../form-elements/Signature';
import SingleChoice from '../form-elements/SingleChoice';
import TextInput from '../form-elements/TextInput';
import Title from '../form-elements/Title';
import Video from '../form-elements/Video';
import { ItemsTypes } from '../toolbar';

export const mapItemTypeToBaseFormElement = {
  [ItemsTypes.Title]: Title,
  [ItemsTypes.Paragraph]: Paragraph,
  [ItemsTypes.TextInput]: TextInput,
  [ItemsTypes.Select]: Select,
  [ItemsTypes.MultiLineInput]: MultiLineInput,
  [ItemsTypes.SingleChoice]: SingleChoice,
  [ItemsTypes.MultipleChoice]: MultipleChoice,
  [ItemsTypes.Line]: Line,
  [ItemsTypes.FileUpload]: FileUpload,
  [ItemsTypes.Hint]: Hint,
  [ItemsTypes.Video]: Video,
  [ItemsTypes.Date]: Date,
  [ItemsTypes.Signature]: Signature,
};
